import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@environment';
import { hmrBootstrap } from './hmr';
import { persistState } from '@datorama/akita';
import { LicenseManager } from 'ag-grid-enterprise';

const storage = persistState({
    storage: localStorage,
    include: ['session', 'tours', 'dropbox', 'impersonate'],
    preStorageUpdate(storeName, state) {
        if (storeName === 'ui') {
            // Return state without viewportSize since it should always be reloaded.
            return {
                landingPage: state.landingPage,
                url: state.url,
                cssPropertySupport: state.cssPropertySupport
            };
        } else if (storeName === 'tours') {
            return {
                entities: state.entities,
                ids: state.ids
            };
        } else if (storeName === 'session') {
            const { loading, loadingState, ...session } = state;
            return session;
        } else if (storeName === 'dropbox') {
            const { connectedState, basePath, error, loading, access_token, ...dropbox } =
                state;
            return dropbox;
        }
        return state;
    }
});

const providers = [{ provide: 'persistStorage', useValue: storage }];

LicenseManager.setLicenseKey(
    'Evaluation_License-_Not_For_Production_Valid_Until_11_April_2019__MTU1NDkzNzIwMDAwMA==621338d31bd07134d7677320badd116a'
);

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => platformBrowserDynamic(providers).bootstrapModule(AppModule);
if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap);
        persistState({
            include: [
                'session',
                'ui',
                'instrumentsNEW',
                'tours',
                'dropbox',
                'categories',
                'categorizations'
            ]
        });
    } else {
        console.error('HMR is not enabled for webpack-dev-server!');
        console.warn('Are you using the --hmr flag for ng serve?');
    }
} else {
    bootstrap().catch((err) => console.log(err));
}
